import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// common
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import SelectionControl from './../../../common/Forms/SelectionControl/SelectionControl';
import Radio from '@material-ui/core/Radio';
// css
import './TakeTest.scss';

const TakeTest = ({ question, onChangeOption, check, onToogleCheck, ansArray, ansFlag }) => {

	const [correctans, setCorrectAns] = useState('');

	const onChangeOptions = (e) => {
		setCorrectAns(e.target.value);
		onChangeOption(e.target.value);
	}

	const checkCorAns = (option_id) => {
		let classAns = '';
		if (ansArray && ansArray.length > 0) {
			classAns = ansArray.some(val => val === option_id) ? 'y' : 'n';
		}
		return classAns;
	}

	if (question) {
		return (
			<div className={`TakeTest ${ansArray && ansArray.length > 0 ? (ansFlag ? 'userwor' : 'usercor') : ''}`}>
				<div className='question box'>{question.question}</div>
				{check ?
					<div className='row options-list'>
						{question.options.length > 0 && question.options.map((option, i) => (
							<div key={option.id} className={`col-sm-6 ${checkCorAns(option.id)}`}>
								<div className='box'>
									<SelectionControl
										checkbox
										disabled={ansArray && ansArray.length > 0}
										label={option.option_value}
										value={JSON.stringify(option.id)}
										onToogleCheck={(val) => onToogleCheck(val, i)}
									/>
								</div>
							</div>
						))}
					</div>
					:
					<SelectionControl
						name="options"
						value={correctans}
						onChange={(e) => onChangeOptions(e)}
					>
						{question.options.length > 0 && question.options.map(option => (
							<FormControlLabel
								key={option.id}
								className={`${checkCorAns(option.id)}`}
								value={JSON.stringify(option.id)}
								disabled={ansArray && ansArray.length > 0}
								control={<Radio classes={{ root: 'root', checked: 'checked' }} />}
								label={option.option_value}
							/>
						))}
					</SelectionControl>
				}

				{ansArray && ansArray.length > 0 && (
					<React.Fragment>
						<div className='box res-box'>
							{ansFlag ? 'You selected a wrong answer.' : 'Congratulations! You selected the correct answer.'}
						</div>
						{(question.reason || question.url) && (
							<div className="box other-qdetails">
								{question.reason && (
									<div>
										<div className='label'>reason</div>
										<div className='value'>{question.reason}</div>
									</div>
								)}
								{question.url && (
									<div>
										{question.url.match(/http/g) ?
											<a rel={'external'} target="_blank" href={`${question.url}`} >
												Reference Link
										</a>
											:
											<a href={`//${question.url}`} target="_blank">
												Reference Link
										</a>
										}
									</div>
								)}
								{/* {question.url && (
									<CustomButton
										plain
										name='View More....'
										onClick={() => window.open(question.url, '_blank')}
									/>
								)} */}
							</div>
						)}
					</React.Fragment>
				)}
			</div>
		);
	}
	return null;
}

TakeTest.propTypes = {
	question: PropTypes.instanceOf(Object),
	onChangeOption: PropTypes.func,
	check: PropTypes.bool,
	onToogleCheck: PropTypes.func,
	ansArray: PropTypes.instanceOf(Array),
	ansFlag: PropTypes.bool

};

TakeTest.defaultProps = {
	question: {},
	onChangeOption: () => { },
	check: false,
	onToogleCheck: () => { },
	ansArray: [],
	ansFlag: false

};

export default TakeTest;



// WEBPACK FOOTER //
// ./components/Mockexam/TakeTest/TakeTest.js